import { useMemo } from 'react'
import { useQuery } from '@apollo/client'
import { getPgaHopeGroupEventsStartDateTime } from 'lib/coach-profile/marketplace-listing'
import Dashboard from './dashboard'
import { COACH_ONBOARDING_STATUS } from './query'
import Error from 'components/error'
import { flags, useFeatureFlags } from 'lib/feature-flags'
import LoadingSkeleton from './loadingSkeleton'

const DashboardPage = () => {
  const [isMarketplaceListingBannerEnabled] = useFeatureFlags([
    flags.FLAG_FEAT_MARKETPLACE_LISTING_BANNER,
  ])
  const upcomingStartDateTime = useMemo(
    () => getPgaHopeGroupEventsStartDateTime(),
    [],
  )
  const { data, loading, error } = useQuery(COACH_ONBOARDING_STATUS, {
    variables: {
      includeMarketplaceListing: Boolean(isMarketplaceListingBannerEnabled),
      upcomingStartDateTime,
    },
  })

  if (loading) return <LoadingSkeleton />
  if (error) return <Error />

  return <Dashboard data={data} />
}

export default DashboardPage
